export const rolesParaInspeccion = ['ROLE_ADMIN','ROLE_COORDINADOR_INSPECCION','ROLE_INSPECCION'];
export const rolesParaRevisor = ['ROLE_ADMIN','ROLE_JEFE_DEPARTAMENTO','ROLE_SUPERVISOR_FOMENTO',
                                 'ROLE_REVISOR_FOMENTO','ROLE_REVISOR_CIVIL','ROLE_SUPERVISOR_CIVIL',
                                 'ROLE_SUPERVISOR_SUELO','ROLE_REVISOR_SUELO','ROLE_SUPERVISOR_SALUD',
                                 'ROLE_REVISOR_SALUD'];